import React from "react";
import { qreq } from "../../shared/qrequest";
import BaseCom from "../BaseCom";
import Icon from "../Icon";
import { SidebarGlobal } from "../Sidebar";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import './AssetLibrary.css';
import AssetLibraryDirectoryModal from "./AssetLibraryDirectoryModal";
import AppActions from "../AppActions";
import Tick from "../Tick";
import Auth from "../../shared/Auth";
import { Pop } from "../PopModal";
import VideoPlayerModal from "../VideoPlayerModal";
import Globals from "../../shared/Globals";

class AssetLibrary extends BaseCom {
    constructor(props) {
        super(props);

        this.state = {
            list: [],
            queue: []
        };

        this.leaveTimeout = null;
        this.uploadRef = React.createRef();
    }

    async componentDidMount() {
        this.updateSubNav();
        document.addEventListener('drop', this.onFileDrop);
        document.addEventListener('dragover', this.onFileDragOver);
        document.addEventListener('dragleave', this.onFileDragLeave);
        await this.loadItem();
        await this.load();
    }

    componentWillUnmount() {
        document.removeEventListener('drop', this.onFileDrop);
        document.removeEventListener('dragover', this.onFileDragOver);
        document.removeEventListener('dragleave', this.onFileDragLeave);
        this.cancelTimeout();
        SidebarGlobal.clearSubNav();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.params.parentID !== this.props.params.parentID) {
            this.load();
            this.loadItem();
        }
    }

    updateSubNav = () => {
        if (Auth.hasRole('file-manager')) {
            SidebarGlobal.setSubNav(<>
                <button className="btn btn-primary" onClick={this.browseUpload}>
                    <Icon icon="faFileUpload" /> <span className="d-none d-md-inline">Upload Asset</span>
                </button>
                <button className="btn btn-secondary" onClick={this.showDirectoryModal}>
                    <Icon icon="faFolder" /> <span className="d-none d-md-inline">New Directory</span>
                </button>
            </>);
        }
    }

    browseUpload = () => {
        this.uploadRef.current.click();
    }

    uploadChange = (e) => {
        if (e.target.files) {
            [...e.target.files].forEach(f => this.enqueue(f));
        }
    }

    onFileDrop = (e) => {
        e.preventDefault();
        this.cancelTimeout();
        this.setState({ hover: false });

        if (e.dataTransfer && e.dataTransfer.items) {
            [...e.dataTransfer.items].forEach(i => {
                if (i.kind === "file") {
                    const file = i.getAsFile();
                    this.enqueue(file);
                }
            });
        }

    }

    cancelTimeout = () => {
        if (this.hoverTimeout)
            clearTimeout(this.hoverTimeout);
    }

    onFileDragOver = (e) => {
        e.preventDefault();
        this.cancelTimeout();
        this.setState({ hover: true });
    }

    onFileDragLeave = (e) => {
        e.preventDefault();
        this.cancelTimeout();
        this.hoverTimeout = setTimeout(() => {
            this.setState({ hover: false });
        }, 500);
    }

    enqueue = (file) => {
        this.setState({ queue: [...this.state.queue, file] });
    }

    processQueue = async () => {
        if (this.state.queue.length === 0 || this.state.uploading)
            return;

        let file = this.state.queue[0];
        this.setState({ queue: this.state.queue.slice(1) });
        await this.upload(file);
    }

    upload = async (file) => {
        try {
            this.setState({ uploading: file });
            let formData = new FormData();
            formData.append('file', file);
            let j = await qreq.postformAsync('/api/asset-library/upload?parentID=' + this.getParentID(),
                formData,
                this.progress);
            if (j.errorCode === 0) {
                this.load();
            }
            else {
                this.alert(j.errorMessage);
            }

        }
        catch (e) {
            console.error(e);
            this.unkownErrorCallback();
        }
        this.setState({ uploading: null });
    }

    progress = (percent) => {
        this.setState({ uploadingPercent: percent });
    }

    getUploadingPercent = () => {
        if(this.state.uploadingPercent)
            return this.state.uploadingPercent.toFixed(2) + '%';
        return null;
    }

    showDirectoryModal = () => {
        this.setState({ showDirectoryModal: true });
    }

    getParentID = () => {
        return parseInt(this.props.params.parentID ?? 0);
    }

    load = async () => {
        try {
            let j = await qreq.getAsync('/api/asset-library/list?parentID=' + this.getParentID());
            if (j.list)
                this.setState({ list: j.list });
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            console.error(e);
            this.unkownErrorCallback();
        }
    }

    loadItem = async () => {
        if (this.getParentID() === 0) {
            this.setState({ item: null });
            return;
        }
        try {
            let j = await qreq.getAsync('/api/asset-library/item?id=' + this.getParentID());
            if (j.item)
                this.setState({ item: j.item });
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            console.error(e);
            this.unkownErrorCallback();
        }
    }

    rowClick = (item) => {
        if (item.rename)
            return;
        if (item.isDirectory) {
            this.props.navigate('/asset-library/' + String(item.id));
        }
        else {
            if (item.mimeType.startsWith('video/')) {
                this.setState({ videoModal: true, videoModalSrc: Globals.serverUrl + '/api/asset-library/download/' + item.id, videoModalType: item.mimeType });
            }
        }
    }

    delete = async (item, e) => {
        e?.stopPropagation();
        let itemType = item.isDirectory ? 'directory' : 'file';
        Pop.showConfirm(<>Are you sure you want to delete <i>{itemType}</i> <strong>{item.name}</strong>?</>, 'Delete ' + itemType, async () => {
            try {
                let j = await qreq.postAsync('/api/asset-library/delete', { id: item.id });
                if (j.errorCode === 0) {
                    this.load();
                }
                else {
                    this.alert(j.errorMessage);
                }
            }
            catch (e) {
                console.error(e);
                this.unkownErrorCallback();
            }
        });
    }

    showRename = (item, on, e) => {
        e?.stopPropagation();
        item.rename = on;
        if (on)
            item.newName = item.name;
        this.setState({ list: [...this.state.list] });
    }

    rename = (item, e) => {
        e.stopPropagation();
        if (!item.newName) {
            this.alert('Name cannot be empty');
            return;
        }
        item.rename = false;
        qreq.postAsync('/api/asset-library/rename', { id: item.id, name: item.newName }).then(j => {
            if (j.errorCode === 0) {
                this.load();
            }
            else {
                this.alert(j.errorMessage);
            }
        }).catch(e => {
            console.error(e);
            this.unkownErrorCallback();
        });
    }

    render() {
        return (
            <div className="container-fluid">
                <AssetLibraryDirectoryModal
                    show={this.state.showDirectoryModal}
                    onHide={() => this.setState({ showDirectoryModal: false })}
                    onUpdate={this.load}
                    parentID={this.getParentID()}
                />
                <VideoPlayerModal
                    show={this.state.videoModal}
                    onHide={() => this.setState({ videoModal: false })}
                    src={this.state.videoModalSrc}
                    type={this.state.videoModalType}
                    autoplay
                />
                <input type="file" ref={this.uploadRef} style={{ display: 'none' }} onChange={this.uploadChange} />
                <Tick interval={100} onTick={this.processQueue} />
                {this.state.hover && <div className="asset-library-dropzone-upload">
                    <div className="fs-2"><Icon icon="faUpload" /> Drop files here to upload</div>
                </div>}
                <h1>
                    <span>Asset Library</span>
                    {this.state.item && <span className="fs-6 text-muted"> - {this.state.item.name}</span>}
                </h1>
                <table className="table table-striped">
                    <tbody>
                        {this.state.item?.id ? <tr role="button" onClick={() => this.props.navigate('/asset-library/' + this.state.item.parentID)}>
                            <td style={{ width: '3rem' }}><Icon icon="faArrowUp" /></td>
                            <td colSpan={3}>Up One Level</td>
                        </tr> : ''}
                        {this.state.uploading && <tr>
                            <td colSpan={3}>Uploading: {this.state.uploading.name} {this.getUploadingPercent()}</td>
                        </tr>}
                        {this.state.list?.map((i, idx) => <tr key={idx} role="button" style={{ verticalAlign: 'middle' }} onClick={() => this.rowClick(i)}>
                            {i.isDirectory ? <>
                                <td style={{ width: '3rem' }}><Icon icon="faFolder" /></td>
                                <td>
                                    {i.rename ? <input type="text" className="form-control" value={i.newName} onChange={(e) => { i.newName = e.target.value; this.setState({ list: [...this.state.list] }); }} autoFocus />
                                        : i.name}
                                </td>
                                <td className="text-end" style={{ width: '10rem' }}>
                                    {i.rename ? <>
                                        <button className="btn btn-success" onClick={(e) => this.rename(i, e)}>
                                            <Icon icon="faCheck" />
                                        </button>
                                        <button className="btn btn-secondary" onClick={(e) => this.showRename(i, false, e)}>
                                            <Icon icon="faCancel" />
                                        </button>
                                    </>
                                        : Auth.hasRole('file-manager') && <>
                                            <button className="btn btn-secondary" onClick={(e) => this.showRename(i, true, e)}>
                                                <Icon icon="faPenToSquare" />
                                            </button>
                                            <button className="btn btn-danger" onClick={(e) => this.delete(i, e)}>
                                                <Icon icon="faTrash" />
                                            </button>
                                        </>}
                                </td>
                            </>
                                : <>
                                    <td>
                                        {i.isVideo ? <Icon icon="faVideo" />
                                            : <Icon icon="faFile" />}
                                    </td>
                                    <td>
                                        {i.rename ? <input type="text" className="form-control" value={i.newName} onChange={(e) => { i.newName = e.target.value; this.setState({ list: [...this.state.list] }); }} autoFocus />
                                            : i.name}

                                    </td>
                                    <td className="text-end" style={{ width: '10rem' }}>
                                        {i.rename ? <>
                                            <button className="btn btn-success" onClick={(e) => this.rename(i, e)}>
                                                <Icon icon="faCheck" />
                                            </button>
                                            <button className="btn btn-secondary" onClick={(e) => this.showRename(i, false, e)}>
                                                <Icon icon="faCancel" />
                                            </button>
                                        </>
                                            : Auth.hasRole('file-manager') && <>
                                                <button className="btn btn-secondary" onClick={(e) => this.showRename(i, true, e)}>
                                                    <Icon icon="faPenToSquare" />
                                                </button>
                                                <button className="btn btn-danger" onClick={(e) => this.delete(i, e)}>
                                                    <Icon icon="faTrash" />
                                                </button>
                                            </>}
                                    </td>
                                </>}
                        </tr>)}
                        {this.state.list?.length === 0 && <tr>
                            <td colSpan={3}><i>Empty Directory</i></td>
                        </tr>}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default withParamsAndNavigate(AssetLibrary);